import React, { useContext } from 'react'
import { ConfirmationContext } from '../../../../../Confirmation'
import { useDownloadControlsReport } from '../../../../../components/async/model/control'
import { ReportExportFormat } from '../../../../../Utils/reports/ControlsReport'

export function useDownloadControlsReportModal(
  format: ReportExportFormat = 'csv',
): () => void {
  const { setConfirmationState } = useContext(ConfirmationContext)
  const onConfirmCB = useDownloadControlsReport(undefined, format)
  const isXlsx = format === 'xlsx'
  const formatLabel = isXlsx ? 'XLSX' : 'CSV'
  const fileTypeDescription = isXlsx ? 'an excel (xlsx) file' : 'a csv file'

  return () => {
    setConfirmationState({
      isShown: true,
      size: 'lg',
      title: `Export Control Detail ${formatLabel}`,
      body: (
        <p>
          Trustero will gather the data to create {fileTypeDescription} of
          working controls.
        </p>
      ),
      confirmText: `Export Control ${formatLabel}`,
      onConfirmCB,
    })
  }
}
